/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import style from './style.css';
import _round from 'lodash/round';
import _isPlainObject from 'lodash/isPlainObject';

const Table = props => {
    const data = Object.keys(props.data).length > 0 ? props.data : props.fakeData;

    const comparisonGroupTitle1 = props.groupLabels[0];
    const comparisonGroupTitle2 = props.groupLabels[1];

    const { currentGroup } = data;
    const comparisonGroupKeys = Object.keys(data).filter(x => x !== 'currentGroup');
    const comparisonGroup1 = data[comparisonGroupKeys[0]];
    const comparisonGroup2 = data[comparisonGroupKeys[1]];

    const currentGroupHasData =
        _isPlainObject(currentGroup) && Object.keys(currentGroup).length > 0;
    const comparisonGroup1ExistsWithData =
        _isPlainObject(comparisonGroup1) && Object.keys(comparisonGroup1).length > 0;
    const comparisonGroup2ExistsWithData =
        _isPlainObject(comparisonGroup2) && Object.keys(comparisonGroup2).length > 0;

    if (!currentGroupHasData) {
        return (
            <div className="alert alert-info">
                Could not find data for your group for this time period.
            </div>
        );
    }

    return (
        <table className={style.tg} style={{ tableLayout: 'fixed', width: '100%' }}>
            <colgroup>
                <col style={{ width: '60px' }} />
                <col style={{ width: '60px' }} />
                {comparisonGroup1ExistsWithData && <col style={{ width: '60px' }} />}
                {comparisonGroup2ExistsWithData && <col style={{ width: '60px' }} />}
            </colgroup>
            <thead>
                <tr>
                    <th className={style.tgHeading}>Domain/Factor</th>
                    <th className={style.tgHeading}>{currentGroup.State_Name || 'Self'}</th>
                    {comparisonGroup1ExistsWithData && (
                        <th className={style.tgHeading}>{comparisonGroupTitle1}</th>
                    )}
                    {comparisonGroup2ExistsWithData && (
                        <th className={style.tgHeading}>{comparisonGroupTitle2}</th>
                    )}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className={`${style.tgCell} ${style.domain}`}>Student Population</td>
                    <td className={style.tgCell}>
                        {currentGroup.Student_Population.toLocaleString()}
                    </td>
                    {comparisonGroup1ExistsWithData && (
                        <td className={style.tgCell}>
                            {comparisonGroup1.Student_Population.toLocaleString()}
                        </td>
                    )}
                    {comparisonGroup2ExistsWithData && (
                        <td className={style.tgCell}>
                            {comparisonGroup2.Student_Population.toLocaleString()}
                        </td>
                    )}
                </tr>
                <tr>
                    <td className={`${style.tgCell} ${style.domain}`}>
                        TOTAL NURSING FTE
                        <ul>
                            <li>RN</li>
                            <li>LPN/LVN</li>
                            <li>Health Aide</li>
                        </ul>
                    </td>
                    <td className={style.tgCell}>
                        <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
                            <li style={{ fontWeight: 'bold' }}>
                                {currentGroup.Total_Nursing_FTE &&
                                    currentGroup.Total_Nursing_FTE.toLocaleString() + ' total'}
                            </li>
                            <li>
                                {currentGroup.RN_Total_FTE &&
                                    currentGroup.RN_Total_FTE.toLocaleString() + ' RN'}
                            </li>
                            <li>
                                {currentGroup.LPN_LVN_Total_FTE &&
                                    currentGroup.LPN_LVN_Total_FTE.toLocaleString() + ' LPN/LVN'}
                            </li>
                            <li>
                                {currentGroup.Health_Aide_Total_FTE &&
                                    currentGroup.Health_Aide_Total_FTE.toLocaleString() + ' Aide'}
                            </li>
                        </ul>
                    </td>
                    {comparisonGroup1ExistsWithData && (
                        <td className={style.tgCell}>
                            <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
                                <li style={{ fontWeight: 'bold' }}>
                                    {comparisonGroup1.Total_Nursing_FTE &&
                                        comparisonGroup1.Total_Nursing_FTE.toLocaleString() +
                                            ' total'}
                                </li>
                                <li>
                                    {comparisonGroup1.RN_Total_FTE &&
                                        comparisonGroup1.RN_Total_FTE.toLocaleString() + ' RN'}
                                </li>
                                <li>
                                    {comparisonGroup1.LPN_LVN_Total_FTE &&
                                        comparisonGroup1.LPN_LVN_Total_FTE.toLocaleString() +
                                            ' LPN/LVN'}
                                </li>
                                <li>
                                    {comparisonGroup1.Health_Aide_Total_FTE &&
                                        comparisonGroup1.Health_Aide_Total_FTE.toLocaleString() +
                                            ' Aide'}
                                </li>
                            </ul>
                        </td>
                    )}
                    {comparisonGroup2ExistsWithData && (
                        <td className={style.tgCell}>
                            <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
                                <li style={{ fontWeight: 'bold' }}>
                                    {comparisonGroup2.Total_Nursing_FTE &&
                                        comparisonGroup2.Total_Nursing_FTE.toLocaleString() +
                                            ' total'}
                                </li>
                                <li>
                                    {comparisonGroup2.RN_Total_FTE &&
                                        comparisonGroup2.RN_Total_FTE.toLocaleString() + ' RN'}
                                </li>
                                <li>
                                    {comparisonGroup2.LPN_LVN_Total_FTE &&
                                        comparisonGroup2.LPN_LVN_Total_FTE.toLocaleString() +
                                            ' LPN/LVN'}
                                </li>
                                <li>
                                    {comparisonGroup2.Health_Aide_Total_FTE &&
                                        comparisonGroup2.Health_Aide_Total_FTE.toLocaleString() +
                                            ' Aide'}
                                </li>
                            </ul>
                        </td>
                    )}
                </tr>
                <tr>
                    <td className={`${style.tgCell} ${style.domain}`}>Asthma (per 1000)</td>
                    <td className={style.tgCell}>
                        {_round(currentGroup.Total_Students_Asthma_Per_1000, 2)}
                    </td>
                    {comparisonGroup1ExistsWithData && (
                        <td className={style.tgCell}>
                            {_round(comparisonGroup1.Total_Students_Asthma_Per_1000, 2)}
                        </td>
                    )}
                    {comparisonGroup2ExistsWithData && (
                        <td className={style.tgCell}>
                            {_round(comparisonGroup2.Total_Students_Asthma_Per_1000, 2)}
                        </td>
                    )}
                </tr>
                <tr>
                    <td className={`${style.tgCell} ${style.domain}`}>
                        Type 1 Diabetes (per 1000)
                    </td>
                    <td className={style.tgCell}>
                        <div>{_round(currentGroup.Total_Students_Type_1_Diabetes_Per_1000, 2)}</div>
                    </td>
                    {comparisonGroup1ExistsWithData && (
                        <td className={style.tgCell}>
                            <div>
                                {_round(
                                    comparisonGroup1.Total_Students_Type_1_Diabetes_Per_1000,
                                    2
                                )}
                            </div>
                        </td>
                    )}
                    {comparisonGroup2ExistsWithData && (
                        <td className={style.tgCell}>
                            <div>
                                {_round(
                                    comparisonGroup2.Total_Students_Type_1_Diabetes_Per_1000,
                                    2
                                )}
                            </div>
                        </td>
                    )}
                </tr>
                <tr>
                    <td className={`${style.tgCell} ${style.domain}`}>
                        Type 2 Diabetes (per 1000)
                    </td>
                    <td className={style.tgCell}>
                        <div>{_round(currentGroup.Total_Students_Type_2_Diabetes_Per_1000, 2)}</div>
                    </td>
                    {comparisonGroup1ExistsWithData && (
                        <td className={style.tgCell}>
                            <div>
                                {_round(
                                    comparisonGroup1.Total_Students_Type_2_Diabetes_Per_1000,
                                    2
                                )}
                            </div>
                        </td>
                    )}
                    {comparisonGroup2ExistsWithData && (
                        <td className={style.tgCell}>
                            <div>
                                {_round(
                                    comparisonGroup2.Total_Students_Type_2_Diabetes_Per_1000,
                                    2
                                )}
                            </div>
                        </td>
                    )}
                </tr>
                <tr>
                    <td className={`${style.tgCell} ${style.domain}`}>
                        Seizure Disorder (per 1000)
                    </td>
                    <td className={style.tgCell}>
                        <div>
                            {_round(currentGroup.Total_Students_Seizure_Disorder_Per_1000, 2)}
                        </div>
                    </td>
                    {comparisonGroup1ExistsWithData && (
                        <td className={style.tgCell}>
                            <div>
                                {_round(
                                    comparisonGroup1.Total_Students_Seizure_Disorder_Per_1000,
                                    2
                                )}
                            </div>
                        </td>
                    )}
                    {comparisonGroup2ExistsWithData && (
                        <td className={style.tgCell}>
                            <div>
                                {_round(
                                    comparisonGroup2.Total_Students_Seizure_Disorder_Per_1000,
                                    2
                                )}
                            </div>
                        </td>
                    )}
                </tr>
                <tr>
                    <td className={`${style.tgCell} ${style.domain}`}>
                        Life Threatening Allergy (per 1000)
                    </td>
                    <td className={style.tgCell}>
                        {_round(currentGroup.Total_Students_Life_Threatening_Allergy_Per_1000, 2)}
                    </td>
                    {comparisonGroup1ExistsWithData && (
                        <td className={style.tgCell}>
                            {_round(
                                comparisonGroup1.Total_Students_Life_Threatening_Allergy_Per_1000,
                                2
                            )}
                        </td>
                    )}
                    {comparisonGroup2ExistsWithData && (
                        <td className={style.tgCell}>
                            {_round(
                                comparisonGroup2.Total_Students_Life_Threatening_Allergy_Per_1000,
                                2
                            )}
                        </td>
                    )}
                </tr>
                <tr>
                    <td className={`${style.tgCell} ${style.domain}`}>ME/CFS (per 1000)</td>
                    <td className={style.tgCell}>
                        {_round(currentGroup.Total_Students_ME_CFS_Per_1000, 2)}
                    </td>
                    {comparisonGroup1ExistsWithData && (
                        <td className={style.tgCell}>
                            {_round(comparisonGroup1.Total_Students_ME_CFS_Per_1000, 2)}
                        </td>
                    )}
                    {comparisonGroup2ExistsWithData && (
                        <td className={style.tgCell}>
                            {_round(comparisonGroup2.Total_Students_ME_CFS_Per_1000, 2)}
                        </td>
                    )}
                </tr>
            </tbody>
        </table>
    );
};

export default Table;
